export default "__VITE_ASSET__BppAcvgG__"